<app-navbar></app-navbar>
<div class="body-background">
<div class="container-fluid container-result">  
<div class="box-0">
<div class="d-flex">
<img src="{{imgSrc}}info-sign.svg" alt="info-arrow" class="img-icon img-fluid">
<div class="text-box">We have analysed the market and unfortunately you don’t seems to be eligible for any loan.</div>
</div>


</div>









</div></div>
<app-footer></app-footer>
